export const ACCESS_APPLICATION = 'main:view';
